export var CHANGE_STATION_ID = 'CHANGE_STATION_ID';
export var setStationId = function (stationId) { return function (dispatch) {
    return dispatch({
        type: CHANGE_STATION_ID,
        data: stationId,
    });
}; };
